var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addresses.length >= 1)?_c('b-input-group',{attrs:{"prepend":"Sucursal"}},[_c('b-form-select',{attrs:{"disabled":_vm.disabled,"dusk":"address_id","options":_vm.getOptions({key: 'address_id', text: 'Direccion'})},model:{value:(_vm.address_id),callback:function ($$v) {_vm.address_id=$$v},expression:"address_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }